import PrePaymentTCModalRequestContentContainer from './PrePaymentTCRequestModalContentContainer';

export default PrePaymentTCModalRequestContentContainer;
